"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBrowserStorageCache = void 0;
var katal_weblab_1 = require("@amzn/katal-weblab");
var DEFAULT_TTL_SECONDS = 10 * 60;
/**
 * Creates a new `BrowserStorageCache` for use within Seller Central.
 * Automatically namespaces the weblab cache by the marketplace id set by CSM
 * if it is found on the page. Since weblabs can be dialed up on a
 * per-marketplace basis, this prevents using a stale cached value on
 * marketplace changes.
 *
 * @param applicationName The name of the application.
 * @param ttl The time in seconds the weblab should be cached for. Defaults to
 *     10 minutes.
 * @return A new `BrowserStorageCache` instance.
 */
function createBrowserStorageCache(applicationName, ttl) {
    if (ttl === void 0) { ttl = DEFAULT_TTL_SECONDS; }
    var marketplaceId = window.ue_mid || undefined;
    return new katal_weblab_1.BrowserStorageCache(applicationName, ttl, marketplaceId);
}
exports.createBrowserStorageCache = createBrowserStorageCache;
